module.exports = __webpack_public_path__ + "img/ios 1@2x.836fbbda.png";